if (document.documentElement.lang.split('-')[0] === 'hu') {
/* ePixel - selector unic de variante pentru carduri si pentru pagina de produs:
   fiecare optiune se deschide intr-un panou cu poza, pret si cautare.
   Pe pagina de produs, selectorul arata si pretul cu reducerea in dreapta.
   Optiunile cu o singura valoare se arata ca eticheta, nu ca dropdown.
   Selectul nativ ramane in pagina (ascuns) si primeste schimbarile, deci logica temei nu se schimba. */
(function () {
  if (window.__pbCardLoaded) return;
  window.__pbCardLoaded = true;

  var SEARCH_FROM = 8;
  var pendingQty = 1;

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/(\d)\s*[-\/,]\s*(\d)/g, '$1.$2')
      .replace(/[^a-z0-9.]+/g, ' ')
      .trim();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function splitName(v) {
    var t = v.trim().split(/\s+/);
    if (t.length < 2) return { code: v, name: '' };
    if (!/^[0-9][0-9.\-\/]*[A-Za-z+]?$/.test(t[0])) return { code: v, name: '' };
    var rest = t.slice(1).join(' ');
    if (rest.length <= 3) return { code: v, name: '' };
    return { code: t[0], name: rest };
  }
  function thumbUrl(src) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96&height=96&crop=center';
  }

  function groupNum(cents, dec, thousandsSep, decSep) {
    var n = (cents / 100).toFixed(dec).split('.');
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return n[1] ? whole + decSep + n[1] : whole;
  }
  function formatMoney(cents) {
    var fmt = (window.Eurus && window.Eurus.money_format) || '{{amount_with_comma_separator}} lei';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = groupNum(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = groupNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = groupNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = groupNum(cents, 2, "'", '.'); break;
      default: val = groupNum(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }

  function isOptionSelect(sel) {
    if (!sel || sel.tagName !== 'SELECT' || sel.__pbx) return false;
    if (sel.closest('.pb-shade')) return false;
    if (!sel.closest('[data-option-name]') && !sel.closest('.x-variants-data')) return false;
    return sel.querySelectorAll('option[data-option-value-id]').length >= 1;
  }

  function readOptions(sel) {
    return Array.prototype.map.call(sel.options, function (o, i) {
      var id = o.dataset.optionValueId;
      if (!id) return { i: i, blank: true, label: o.textContent.trim() };
      var img = '';
      var avail = o.dataset.available !== 'false';
      var price = null, compare = null;
      var sc = sel.querySelector('script[data-option-value-id="' + id + '"]');
      if (sc) {
        try {
          var v = JSON.parse(sc.textContent);
          img = (v.featured_image && v.featured_image.src) || (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) || '';
          if (typeof v.available === 'boolean') avail = v.available;
          if (typeof v.price === 'number') price = v.price;
          if (typeof v.compare_at_price === 'number') compare = v.compare_at_price;
        } catch (e) {}
      }
      var sn = splitName(o.value);
      return { i: i, id: id, val: o.value, code: sn.code, name: sn.name, img: img, avail: avail, price: price, compare: compare };
    });
  }
  function thumbHTML(o, fallbackImg) {
    var src = o.img || fallbackImg;
    if (src) return '<span class="pbx-thumb"><img src="' + esc(thumbUrl(src)) + '" alt="" loading="lazy" width="48" height="48"></span>';
    return '<span class="pbx-thumb"><span class="pbx-ph">' + esc(o.code.slice(0, 6)) + '</span></span>';
  }
  function textHTML(o) {
    return '<span class="pbx-text">' +
      (o.code ? '<span class="pbx-code">' + esc(o.code) + '</span>' : '') +
      (o.name ? '<span class="pbx-name">' + esc(o.name) + '</span>' : '') +
      '</span>';
  }
  function priceHTML(o) {
    var html = '';
    if (o.price !== null) {
      var sale = o.compare !== null && o.compare > o.price;
      html += '<span class="pbx-price-row">';
      if (sale) {
        var pct = Math.round((1 - o.price / o.compare) * 100);
        if (pct > 0) html += '<span class="pbx-off">-' + pct + '%</span>';
      }
      html += '<span class="pbx-now' + (sale ? ' is-sale' : '') + '">' + esc(formatMoney(o.price)) + '</span></span>';
      if (sale) {
        html += '<span class="pbx-was">' + esc(formatMoney(o.compare)) + '</span>';
        html += '<span class="pbx-savings" aria-label="Megtakarítás: ' + esc(formatMoney(o.compare - o.price)) + '">−' + esc(formatMoney(o.compare - o.price)) + '</span>';
      }
    }
    if (!o.avail) html += '<span class="pbx-oos">Elfogyott</span>';
    return html ? '<span class="pbx-price">' + html + '</span>' : '';
  }

  function buildQty() {
    var qty = document.createElement('div');
    qty.className = 'pbx-qty';
    qty.innerHTML =
      '<button type="button" class="pbx-qty-btn" data-d="-1" aria-label="Scade cantitatea">&minus;</button>' +
      '<input type="number" value="1" min="1" max="99" inputmode="numeric" aria-label="Mennyiség">' +
      '<button type="button" class="pbx-qty-btn" data-d="1" aria-label="Cre\u0219te cantitatea">+</button>';
    return qty;
  }

  function attachBuy(card) {
    if (!card || card.classList.contains('pbx-has-buy')) return;
    if (card.closest('.choose-options') || card.closest('.js-product-container')) return;
    var atc = card.querySelector('.quick-view-container [x-data="xProductCart"]') || card.querySelector('.bottom_atc[x-data="xProductCart"]');
    if (!atc) return;
    var form = atc.querySelector('form[action*="/cart/add"]');
    var content = card.querySelector('[id^="x-product-template-"]');
    var variants = card.querySelector('.x-variants-data-js') || card.querySelector('.x-variants-data');
    if (!content && !variants) return;

    var buy = document.createElement('div');
    buy.className = 'pbx-buy';
    if (variants && variants.parentNode) variants.parentNode.insertBefore(buy, variants);
    else content.appendChild(buy);

    var row = document.createElement('div');
    row.className = 'pbx-row';
    buy.appendChild(row);
    if (variants) row.appendChild(variants);
    else row.classList.add('pbx-row--empty');

    var line = document.createElement('div');
    line.className = 'pbx-line';
    buy.appendChild(line);

    var qty = buildQty();
    // List cards add one piece; quantity remains editable in the cart.
    // Keep the internal default for the native quick-view handoff.
    var inp = qty.querySelector('input');
    var hid = null;
    if (form) {
      hid = form.querySelector('input[name="quantity"]');
      if (!hid) {
        hid = document.createElement('input');
        hid.type = 'hidden';
        hid.name = 'quantity';
        hid.value = '1';
        form.appendChild(hid);
      }
    }
    function setQty(v) {
      v = parseInt(v, 10);
      v = v >= 1 ? Math.min(99, v) : 1;
      inp.value = v;
      if (hid) hid.value = v;
    }
    qty.addEventListener('click', function (e) {
      var b = e.target.closest('.pbx-qty-btn');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      setQty((parseInt(inp.value, 10) || 1) + Number(b.dataset.d));
    });
    inp.addEventListener('input', function () {
      var v = parseInt(inp.value, 10);
      if (v >= 1 && hid) hid.value = Math.min(99, v);
    });
    inp.addEventListener('change', function () { setQty(inp.value); });

    var box = document.createElement('div');
    box.className = 'pbx-atc';
    line.appendChild(box);
    box.appendChild(atc);
    box.addEventListener('click', function () {
      pendingQty = parseInt(inp.value, 10) || 1;
      if (!form) setTimeout(applyPendingQty, 300);
      if (!form) setTimeout(applyPendingQty, 900);
    }, true);
    card.classList.add('pbx-has-buy');
  }

  function applyPendingQty() {
    document.querySelectorAll('.choose-options form[action*="/cart/add"], .js-product-container form[action*="/cart/add"]').forEach(function (f) {
      if (f.offsetParent === null) return;
      var native = f.querySelector('input[name="quantity"]');
      if (native && native.type !== 'hidden') {
        if (String(native.value) !== String(pendingQty)) {
          native.value = pendingQty;
          native.dispatchEvent(new Event('input', { bubbles: true }));
          native.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      if (!native) {
        native = document.createElement('input');
        native.type = 'hidden';
        native.name = 'quantity';
        f.appendChild(native);
      }
      native.value = pendingQty;
    });
  }

  function optionLabel(sel) {
    var wrap = sel.closest('[data-option-name]');
    var lab = wrap && wrap.querySelector('label');
    if (lab && lab.textContent.trim()) return lab.textContent.trim();
    if (wrap && wrap.dataset.optionTitle) return wrap.dataset.optionTitle;
    return sel.name || 'variant\u0103';
  }
  function fallbackImage(sel) {
    var scope = sel.closest('.card-product') || sel.closest('.main-product') || document;
    var img = scope.querySelector('.preview-img, .product__media img, picture img');
    return img ? (img.getAttribute('src') || '').split('?')[0] : '';
  }

  function enhance(sel) {
    if (!isOptionSelect(sel)) return;
    var wrap = sel.closest('.select') || sel.parentElement;
    var st = {
      sel: sel,
      opts: readOptions(sel),
      layer: null,
      active: -1,
      label: optionLabel(sel),
      img: fallbackImage(sel),
      showPrice: !!sel.closest('[id^="variant-update-"]') /* pagina de produs si quick view */
    };
    sel.__pbx = st;
    var values = st.opts.filter(function (o) { return !o.blank; });
    st.single = values.length < 2;
    // Rename only size-like quantities on cards; never number of pieces or PDP options.
    if (sel.closest('.card-product') && st.label.toLowerCase() === 'cantitate' && values.length && values.every(function (o) { return /\b(?:ml|g|kg|l)\b/i.test(o.label); })) {
      st.label = 'Gramaj';
      var optionWrap = sel.closest('[data-option-name]');
      var optionHeading = optionWrap && optionWrap.querySelector('label');
      if (optionHeading) optionHeading.textContent = st.label;
    }


    var trig = document.createElement('button');
    trig.type = 'button';
    trig.className = 'pbx-trigger' + (st.single ? ' pbx-trigger--static' : '');
    if (st.single) {
      trig.setAttribute('tabindex', '-1');
      trig.setAttribute('aria-disabled', 'true');
    } else {
      trig.setAttribute('aria-haspopup', 'dialog');
    }
    trig.setAttribute('aria-label', st.label);
    wrap.insertAdjacentElement('afterend', trig);
    wrap.classList.add('pbx-native');
    st.trig = trig;

    function renderTrigger() {
      var o = st.opts[sel.selectedIndex] || values[0];
      if (o && !o.blank) {
        var extra = st.showPrice ? priceHTML(o) : (o.avail ? '' : '<span class="pbx-oos">Epuizat</span>');
        trig.innerHTML = thumbHTML(o, st.img) + textHTML(o) + extra;
      } else {
        trig.innerHTML = '<span class="pbx-text"><span>' + esc(o ? o.label : 'Alege') + '</span></span>';
      }
      if (!st.single) trig.insertAdjacentHTML('beforeend', '<span class="pbx-caret" aria-hidden="true"></span>');
    }
    st.renderTrigger = renderTrigger;
    renderTrigger();
    sel.addEventListener('change', renderTrigger);

    if (!st.single) {
      trig.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPanel(st);
      });
    }
  }

  function itemHTML(o, img) {
    return '<li class="pbx-item' + (o.avail ? '' : ' is-unavailable') + '" role="option" data-index="' + o.i + '" data-search="' + esc(o.val) + '">' +
      thumbHTML(o, img) + textHTML(o) + priceHTML(o) + '</li>';
  }

  function buildLayer(st) {
    var sel = st.sel;
    var layer = document.createElement('div');
    layer.className = 'pbx-layer';
    layer.hidden = true;
    layer.__owner = st.trig;
    var list = st.opts.filter(function (o) { return !o.blank; });
    var items = list.map(function (o) { return itemHTML(o, st.img); }).join('');
    var scope = sel.closest('.card-product, .choose-options, .main-product, .x-product-data-container');
    var titleEl = scope && scope.querySelector('.x-card-title, .card__heading a, h1, h2, h3');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var heading = 'Alege ' + st.label.toLowerCase();
    layer.innerHTML =
      '<div class="pbx-backdrop"></div>' +
      '<div class="pbx-panel" role="dialog" aria-modal="true" aria-label="' + esc(heading) + '">' +
        '<div class="pbx-head"><span class="pbx-title">' + esc(heading) + (title ? '<br><small style="font-weight:400;opacity:.7">' + esc(title) + '</small>' : '') + '</span>' +
        '<button type="button" class="pbx-close" aria-label="\u00cenchide">&times;</button></div>' +
        '<div class="pbx-search"' + (list.length < SEARCH_FROM ? ' hidden' : '') + '><input type="search" inputmode="search" autocomplete="off" enterkeyhint="search" placeholder="Keresés a listában" aria-label="Keresés"></div>' +
        '<ul class="pbx-list" role="listbox">' + items + '</ul>' +
        '<p class="pbx-empty" hidden>Nimic g\u0103sit. \u00cencearc\u0103 doar codul, ex. 7.0</p>' +
      '</div>';
    document.body.appendChild(layer);

    st.list = layer.querySelector('.pbx-list');
    st.input = layer.querySelector('input');
    st.searchWrap = layer.querySelector('.pbx-search');
    st.empty = layer.querySelector('.pbx-empty');
    st.lis = Array.prototype.slice.call(st.list.children);
    st.lis.forEach(function (li) { li._s = norm(li.getAttribute('data-search')); });

    layer.querySelector('.pbx-backdrop').addEventListener('click', function () { closePanel(st); });
    layer.querySelector('.pbx-close').addEventListener('click', function () { closePanel(st); });
    st.list.addEventListener('click', function (e) {
      var li = e.target.closest('.pbx-item');
      if (li) choose(st, Number(li.dataset.index));
    });
    st.list.addEventListener('mouseover', function (e) {
      var li = e.target.closest('.pbx-item');
      if (li) setActive(st, Number(li.dataset.index), false);
    });
    st.input.addEventListener('input', function () { filter(st); });
    st.input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(st, 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(st, -1); }
      else if (e.key === 'Enter') { e.preventDefault(); if (st.active >= 0) choose(st, st.active); }
    });
    layer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); closePanel(st); }
    });
    return layer;
  }

  function setActive(st, idx, scroll) {
    st.active = idx;
    st.lis.forEach(function (li) { li.classList.toggle('is-active', Number(li.dataset.index) === idx); });
    if (scroll) {
      var li = st.lis.find(function (l) { return Number(l.dataset.index) === idx; });
      if (li) li.scrollIntoView({ block: 'nearest' });
    }
  }
  function filter(st) {
    var raw = norm(st.input.value);
    var tokens = raw.split(' ').filter(Boolean);
    var useful = tokens.filter(function (t) { return st.lis.some(function (li) { return li._s.indexOf(t) > -1; }); });
    var first = null, visible = 0;
    st.lis.forEach(function (li) {
      var ok = !raw ? true : (!useful.length ? false : useful.every(function (t) { return li._s.indexOf(t) > -1; }));
      li.hidden = !ok;
      if (ok) { visible++; if (first === null) first = Number(li.dataset.index); }
    });
    st.empty.hidden = !(raw && visible === 0);
    if (raw) { st.list.scrollTop = 0; setActive(st, first === null ? -1 : first, false); }
  }
  function move(st, step) {
    var vis = st.lis.filter(function (li) { return !li.hidden; });
    if (!vis.length) return;
    var pos = vis.findIndex(function (li) { return Number(li.dataset.index) === st.active; });
    pos = pos === -1 ? 0 : (pos + step + vis.length) % vis.length;
    setActive(st, Number(vis[pos].dataset.index), true);
  }
  function refreshAvailability(st) {
    Array.prototype.forEach.call(st.sel.options, function (o, i) {
      var d = st.opts[i];
      if (!d || d.blank) return;
      if (o.dataset.available) d.avail = o.dataset.available !== 'false';
    });
  }
  function openPanel(st) {
    refreshAvailability(st);
    if (!st.layer) st.layer = buildLayer(st);
    var cur = st.sel.selectedIndex;
    st.lis.forEach(function (li) {
      var i = Number(li.dataset.index);
      li.classList.toggle('is-selected', i === cur);
      li.setAttribute('aria-selected', i === cur ? 'true' : 'false');
    });
    st.input.value = '';
    filter(st);
    setActive(st, cur, false);
    st.layer.hidden = false;
    document.documentElement.classList.add('pbx-lock');
    var curLi = st.lis.find(function (l) { return Number(l.dataset.index) === cur; });
    requestAnimationFrame(function () {
      if (curLi) curLi.scrollIntoView({ block: 'center' });
      if (!st.searchWrap.hidden && window.matchMedia('(min-width: 768px)').matches) st.input.focus({ preventScroll: true });
    });
  }
  function closePanel(st) {
    if (!st.layer || st.layer.hidden) return;
    st.layer.hidden = true;
    document.documentElement.classList.remove('pbx-lock');
    if (st.trig && document.contains(st.trig)) st.trig.focus({ preventScroll: true });
  }
  function choose(st, idx) {
    closePanel(st);
    var sel = st.sel;
    if (sel.selectedIndex === idx) return;
    sel.selectedIndex = idx;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function scan(root) {
    var scope = root || document;
    scope.querySelectorAll('select').forEach(enhance);
    scope.querySelectorAll('.card-product').forEach(function (card) {
      try { attachBuy(card); } catch (e) { console.warn('pbx buy', e); }
    });
    try { applyPendingQty(); } catch (e) {}
    document.querySelectorAll('.pbx-layer').forEach(function (layer) {
      if (layer.__owner && !document.contains(layer.__owner) && layer.hidden) layer.remove();
    });
  }
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { scan(document); }, 100);
  }
  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType === 1 && (node.tagName === 'SELECT' || node.tagName === 'FORM' || (node.matches && node.matches('.card-product')) || (node.querySelector && node.querySelector('select, .card-product, form')))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('change', schedule, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

} else {
/* ePixel - selector unic de variante pentru carduri si pentru pagina de produs:
   fiecare optiune se deschide intr-un panou cu poza, pret si cautare.
   Pe pagina de produs, selectorul arata si pretul cu reducerea in dreapta.
   Optiunile cu o singura valoare se arata ca eticheta, nu ca dropdown.
   Selectul nativ ramane in pagina (ascuns) si primeste schimbarile, deci logica temei nu se schimba. */
(function () {
  if (window.__pbCardLoaded) return;
  window.__pbCardLoaded = true;

  var SEARCH_FROM = 8;
  var pendingQty = 1;

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/(\d)\s*[-\/,]\s*(\d)/g, '$1.$2')
      .replace(/[^a-z0-9.]+/g, ' ')
      .trim();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function splitName(v) {
    var t = v.trim().split(/\s+/);
    if (t.length < 2) return { code: v, name: '' };
    if (!/^[0-9][0-9.\-\/]*[A-Za-z+]?$/.test(t[0])) return { code: v, name: '' };
    var rest = t.slice(1).join(' ');
    if (rest.length <= 3) return { code: v, name: '' };
    return { code: t[0], name: rest };
  }
  function thumbUrl(src) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96&height=96&crop=center';
  }

  function groupNum(cents, dec, thousandsSep, decSep) {
    var n = (cents / 100).toFixed(dec).split('.');
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return n[1] ? whole + decSep + n[1] : whole;
  }
  function formatMoney(cents) {
    var fmt = (window.Eurus && window.Eurus.money_format) || '{{amount_with_comma_separator}} lei';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = groupNum(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = groupNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = groupNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = groupNum(cents, 2, "'", '.'); break;
      default: val = groupNum(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }

  function isOptionSelect(sel) {
    if (!sel || sel.tagName !== 'SELECT' || sel.__pbx) return false;
    if (sel.closest('.pb-shade')) return false;
    if (!sel.closest('[data-option-name]') && !sel.closest('.x-variants-data')) return false;
    return sel.querySelectorAll('option[data-option-value-id]').length >= 1;
  }

  function readOptions(sel) {
    return Array.prototype.map.call(sel.options, function (o, i) {
      var id = o.dataset.optionValueId;
      if (!id) return { i: i, blank: true, label: o.textContent.trim() };
      var img = '';
      var avail = o.dataset.available !== 'false';
      var price = null, compare = null;
      var sc = sel.querySelector('script[data-option-value-id="' + id + '"]');
      if (sc) {
        try {
          var v = JSON.parse(sc.textContent);
          img = (v.featured_image && v.featured_image.src) || (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) || '';
          if (typeof v.available === 'boolean') avail = v.available;
          if (typeof v.price === 'number') price = v.price;
          if (typeof v.compare_at_price === 'number') compare = v.compare_at_price;
        } catch (e) {}
      }
      var sn = splitName(o.value);
      return { i: i, id: id, val: o.value, code: sn.code, name: sn.name, img: img, avail: avail, price: price, compare: compare };
    });
  }
  function thumbHTML(o, fallbackImg) {
    var src = o.img || fallbackImg;
    if (src) return '<span class="pbx-thumb"><img src="' + esc(thumbUrl(src)) + '" alt="" loading="lazy" width="48" height="48"></span>';
    return '<span class="pbx-thumb"><span class="pbx-ph">' + esc(o.code.slice(0, 6)) + '</span></span>';
  }
  function textHTML(o) {
    return '<span class="pbx-text">' +
      (o.code ? '<span class="pbx-code">' + esc(o.code) + '</span>' : '') +
      (o.name ? '<span class="pbx-name">' + esc(o.name) + '</span>' : '') +
      '</span>';
  }
  function priceHTML(o) {
    var html = '';
    if (o.price !== null) {
      var sale = o.compare !== null && o.compare > o.price;
      html += '<span class="pbx-price-row">';
      if (sale) {
        var pct = Math.round((1 - o.price / o.compare) * 100);
        if (pct > 0) html += '<span class="pbx-off">-' + pct + '%</span>';
      }
      html += '<span class="pbx-now' + (sale ? ' is-sale' : '') + '">' + esc(formatMoney(o.price)) + '</span></span>';
      if (sale) {
        html += '<span class="pbx-was">' + esc(formatMoney(o.compare)) + '</span>';
        html += '<span class="pbx-savings" aria-label="Economisești ' + esc(formatMoney(o.compare - o.price)) + '">−' + esc(formatMoney(o.compare - o.price)) + '</span>';
      }
    }
    if (!o.avail) html += '<span class="pbx-oos">Stoc epuizat</span>';
    return html ? '<span class="pbx-price">' + html + '</span>' : '';
  }

  function buildQty() {
    var qty = document.createElement('div');
    qty.className = 'pbx-qty';
    qty.innerHTML =
      '<button type="button" class="pbx-qty-btn" data-d="-1" aria-label="Scade cantitatea">&minus;</button>' +
      '<input type="number" value="1" min="1" max="99" inputmode="numeric" aria-label="Cantitate">' +
      '<button type="button" class="pbx-qty-btn" data-d="1" aria-label="Cre\u0219te cantitatea">+</button>';
    return qty;
  }

  function attachBuy(card) {
    if (!card || card.classList.contains('pbx-has-buy')) return;
    if (card.closest('.choose-options') || card.closest('.js-product-container')) return;
    var atc = card.querySelector('.quick-view-container [x-data="xProductCart"]') || card.querySelector('.bottom_atc[x-data="xProductCart"]');
    if (!atc) return;
    var form = atc.querySelector('form[action*="/cart/add"]');
    var content = card.querySelector('[id^="x-product-template-"]');
    var variants = card.querySelector('.x-variants-data-js') || card.querySelector('.x-variants-data');
    if (!content && !variants) return;

    var buy = document.createElement('div');
    buy.className = 'pbx-buy';
    if (variants && variants.parentNode) variants.parentNode.insertBefore(buy, variants);
    else content.appendChild(buy);

    var row = document.createElement('div');
    row.className = 'pbx-row';
    buy.appendChild(row);
    if (variants) row.appendChild(variants);
    else row.classList.add('pbx-row--empty');

    var line = document.createElement('div');
    line.className = 'pbx-line';
    buy.appendChild(line);

    var qty = buildQty();
    // List cards add one piece; quantity remains editable in the cart.
    // Keep the internal default for the native quick-view handoff.
    var inp = qty.querySelector('input');
    var hid = null;
    if (form) {
      hid = form.querySelector('input[name="quantity"]');
      if (!hid) {
        hid = document.createElement('input');
        hid.type = 'hidden';
        hid.name = 'quantity';
        hid.value = '1';
        form.appendChild(hid);
      }
    }
    function setQty(v) {
      v = parseInt(v, 10);
      v = v >= 1 ? Math.min(99, v) : 1;
      inp.value = v;
      if (hid) hid.value = v;
    }
    qty.addEventListener('click', function (e) {
      var b = e.target.closest('.pbx-qty-btn');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      setQty((parseInt(inp.value, 10) || 1) + Number(b.dataset.d));
    });
    inp.addEventListener('input', function () {
      var v = parseInt(inp.value, 10);
      if (v >= 1 && hid) hid.value = Math.min(99, v);
    });
    inp.addEventListener('change', function () { setQty(inp.value); });

    var box = document.createElement('div');
    box.className = 'pbx-atc';
    line.appendChild(box);
    box.appendChild(atc);
    box.addEventListener('click', function () {
      pendingQty = parseInt(inp.value, 10) || 1;
      if (!form) setTimeout(applyPendingQty, 300);
      if (!form) setTimeout(applyPendingQty, 900);
    }, true);
    card.classList.add('pbx-has-buy');
  }

  function applyPendingQty() {
    document.querySelectorAll('.choose-options form[action*="/cart/add"], .js-product-container form[action*="/cart/add"]').forEach(function (f) {
      if (f.offsetParent === null) return;
      var native = f.querySelector('input[name="quantity"]');
      if (native && native.type !== 'hidden') {
        if (String(native.value) !== String(pendingQty)) {
          native.value = pendingQty;
          native.dispatchEvent(new Event('input', { bubbles: true }));
          native.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      if (!native) {
        native = document.createElement('input');
        native.type = 'hidden';
        native.name = 'quantity';
        f.appendChild(native);
      }
      native.value = pendingQty;
    });
  }

  function optionLabel(sel) {
    var wrap = sel.closest('[data-option-name]');
    var lab = wrap && wrap.querySelector('label');
    if (lab && lab.textContent.trim()) return lab.textContent.trim();
    if (wrap && wrap.dataset.optionTitle) return wrap.dataset.optionTitle;
    return sel.name || 'variant\u0103';
  }
  function fallbackImage(sel) {
    var scope = sel.closest('.card-product') || sel.closest('.main-product') || document;
    var img = scope.querySelector('.preview-img, .product__media img, picture img');
    return img ? (img.getAttribute('src') || '').split('?')[0] : '';
  }

  function enhance(sel) {
    if (!isOptionSelect(sel)) return;
    var wrap = sel.closest('.select') || sel.parentElement;
    var st = {
      sel: sel,
      opts: readOptions(sel),
      layer: null,
      active: -1,
      label: optionLabel(sel),
      img: fallbackImage(sel),
      showPrice: !!sel.closest('[id^="variant-update-"]') /* pagina de produs si quick view */
    };
    sel.__pbx = st;
    var values = st.opts.filter(function (o) { return !o.blank; });
    st.single = values.length < 2;
    // Rename only size-like quantities on cards; never number of pieces or PDP options.
    if (sel.closest('.card-product') && st.label.toLowerCase() === 'cantitate' && values.length && values.every(function (o) { return /\b(?:ml|g|kg|l)\b/i.test(o.label); })) {
      st.label = 'Gramaj';
      var optionWrap = sel.closest('[data-option-name]');
      var optionHeading = optionWrap && optionWrap.querySelector('label');
      if (optionHeading) optionHeading.textContent = st.label;
    }


    var trig = document.createElement('button');
    trig.type = 'button';
    trig.className = 'pbx-trigger' + (st.single ? ' pbx-trigger--static' : '');
    if (st.single) {
      trig.setAttribute('tabindex', '-1');
      trig.setAttribute('aria-disabled', 'true');
    } else {
      trig.setAttribute('aria-haspopup', 'dialog');
    }
    trig.setAttribute('aria-label', st.label);
    wrap.insertAdjacentElement('afterend', trig);
    wrap.classList.add('pbx-native');
    st.trig = trig;

    function renderTrigger() {
      var o = st.opts[sel.selectedIndex] || values[0];
      if (o && !o.blank) {
        var extra = st.showPrice ? priceHTML(o) : (o.avail ? '' : '<span class="pbx-oos">Epuizat</span>');
        trig.innerHTML = thumbHTML(o, st.img) + textHTML(o) + extra;
      } else {
        trig.innerHTML = '<span class="pbx-text"><span>' + esc(o ? o.label : 'Alege') + '</span></span>';
      }
      if (!st.single) trig.insertAdjacentHTML('beforeend', '<span class="pbx-caret" aria-hidden="true"></span>');
    }
    st.renderTrigger = renderTrigger;
    renderTrigger();
    sel.addEventListener('change', renderTrigger);

    if (!st.single) {
      trig.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPanel(st);
      });
    }
  }

  function itemHTML(o, img) {
    return '<li class="pbx-item' + (o.avail ? '' : ' is-unavailable') + '" role="option" data-index="' + o.i + '" data-search="' + esc(o.val) + '">' +
      thumbHTML(o, img) + textHTML(o) + priceHTML(o) + '</li>';
  }

  function buildLayer(st) {
    var sel = st.sel;
    var layer = document.createElement('div');
    layer.className = 'pbx-layer';
    layer.hidden = true;
    layer.__owner = st.trig;
    var list = st.opts.filter(function (o) { return !o.blank; });
    var items = list.map(function (o) { return itemHTML(o, st.img); }).join('');
    var scope = sel.closest('.card-product, .choose-options, .main-product, .x-product-data-container');
    var titleEl = scope && scope.querySelector('.x-card-title, .card__heading a, h1, h2, h3');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var heading = 'Alege ' + st.label.toLowerCase();
    layer.innerHTML =
      '<div class="pbx-backdrop"></div>' +
      '<div class="pbx-panel" role="dialog" aria-modal="true" aria-label="' + esc(heading) + '">' +
        '<div class="pbx-head"><span class="pbx-title">' + esc(heading) + (title ? '<br><small style="font-weight:400;opacity:.7">' + esc(title) + '</small>' : '') + '</span>' +
        '<button type="button" class="pbx-close" aria-label="\u00cenchide">&times;</button></div>' +
        '<div class="pbx-search"' + (list.length < SEARCH_FROM ? ' hidden' : '') + '><input type="search" inputmode="search" autocomplete="off" enterkeyhint="search" placeholder="Caut\u0103 în list\u0103" aria-label="Caut\u0103"></div>' +
        '<ul class="pbx-list" role="listbox">' + items + '</ul>' +
        '<p class="pbx-empty" hidden>Nimic g\u0103sit. \u00cencearc\u0103 doar codul, ex. 7.0</p>' +
      '</div>';
    document.body.appendChild(layer);

    st.list = layer.querySelector('.pbx-list');
    st.input = layer.querySelector('input');
    st.searchWrap = layer.querySelector('.pbx-search');
    st.empty = layer.querySelector('.pbx-empty');
    st.lis = Array.prototype.slice.call(st.list.children);
    st.lis.forEach(function (li) { li._s = norm(li.getAttribute('data-search')); });

    layer.querySelector('.pbx-backdrop').addEventListener('click', function () { closePanel(st); });
    layer.querySelector('.pbx-close').addEventListener('click', function () { closePanel(st); });
    st.list.addEventListener('click', function (e) {
      var li = e.target.closest('.pbx-item');
      if (li) choose(st, Number(li.dataset.index));
    });
    st.list.addEventListener('mouseover', function (e) {
      var li = e.target.closest('.pbx-item');
      if (li) setActive(st, Number(li.dataset.index), false);
    });
    st.input.addEventListener('input', function () { filter(st); });
    st.input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(st, 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(st, -1); }
      else if (e.key === 'Enter') { e.preventDefault(); if (st.active >= 0) choose(st, st.active); }
    });
    layer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); closePanel(st); }
    });
    return layer;
  }

  function setActive(st, idx, scroll) {
    st.active = idx;
    st.lis.forEach(function (li) { li.classList.toggle('is-active', Number(li.dataset.index) === idx); });
    if (scroll) {
      var li = st.lis.find(function (l) { return Number(l.dataset.index) === idx; });
      if (li) li.scrollIntoView({ block: 'nearest' });
    }
  }
  function filter(st) {
    var raw = norm(st.input.value);
    var tokens = raw.split(' ').filter(Boolean);
    var useful = tokens.filter(function (t) { return st.lis.some(function (li) { return li._s.indexOf(t) > -1; }); });
    var first = null, visible = 0;
    st.lis.forEach(function (li) {
      var ok = !raw ? true : (!useful.length ? false : useful.every(function (t) { return li._s.indexOf(t) > -1; }));
      li.hidden = !ok;
      if (ok) { visible++; if (first === null) first = Number(li.dataset.index); }
    });
    st.empty.hidden = !(raw && visible === 0);
    if (raw) { st.list.scrollTop = 0; setActive(st, first === null ? -1 : first, false); }
  }
  function move(st, step) {
    var vis = st.lis.filter(function (li) { return !li.hidden; });
    if (!vis.length) return;
    var pos = vis.findIndex(function (li) { return Number(li.dataset.index) === st.active; });
    pos = pos === -1 ? 0 : (pos + step + vis.length) % vis.length;
    setActive(st, Number(vis[pos].dataset.index), true);
  }
  function refreshAvailability(st) {
    Array.prototype.forEach.call(st.sel.options, function (o, i) {
      var d = st.opts[i];
      if (!d || d.blank) return;
      if (o.dataset.available) d.avail = o.dataset.available !== 'false';
    });
  }
  function openPanel(st) {
    refreshAvailability(st);
    if (!st.layer) st.layer = buildLayer(st);
    var cur = st.sel.selectedIndex;
    st.lis.forEach(function (li) {
      var i = Number(li.dataset.index);
      li.classList.toggle('is-selected', i === cur);
      li.setAttribute('aria-selected', i === cur ? 'true' : 'false');
    });
    st.input.value = '';
    filter(st);
    setActive(st, cur, false);
    st.layer.hidden = false;
    document.documentElement.classList.add('pbx-lock');
    var curLi = st.lis.find(function (l) { return Number(l.dataset.index) === cur; });
    requestAnimationFrame(function () {
      if (curLi) curLi.scrollIntoView({ block: 'center' });
      if (!st.searchWrap.hidden && window.matchMedia('(min-width: 768px)').matches) st.input.focus({ preventScroll: true });
    });
  }
  function closePanel(st) {
    if (!st.layer || st.layer.hidden) return;
    st.layer.hidden = true;
    document.documentElement.classList.remove('pbx-lock');
    if (st.trig && document.contains(st.trig)) st.trig.focus({ preventScroll: true });
  }
  function choose(st, idx) {
    closePanel(st);
    var sel = st.sel;
    if (sel.selectedIndex === idx) return;
    sel.selectedIndex = idx;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function scan(root) {
    var scope = root || document;
    scope.querySelectorAll('select').forEach(enhance);
    scope.querySelectorAll('.card-product').forEach(function (card) {
      try { attachBuy(card); } catch (e) { console.warn('pbx buy', e); }
    });
    try { applyPendingQty(); } catch (e) {}
    document.querySelectorAll('.pbx-layer').forEach(function (layer) {
      if (layer.__owner && !document.contains(layer.__owner) && layer.hidden) layer.remove();
    });
  }
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { scan(document); }, 100);
  }
  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType === 1 && (node.tagName === 'SELECT' || node.tagName === 'FORM' || (node.matches && node.matches('.card-product')) || (node.querySelector && node.querySelector('select, .card-product, form')))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('change', schedule, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

}
